const URL_ABSOLUTA_COM_DETALHES =
  /\b([a-z][a-z0-9+.-]*:\/\/[^\s?#"'<>]*)[?#][^\s"'<>]+/gi;
const CAMINHO_COM_DETALHES = /(^|[\s"'(=])(\/[^\s?#"'<>]*)[?#][^\s"'<>]+/g;
const PARAMETRO_SENSIVEL =
  /\b(tokenItem|id_token|access_token|refresh_token|token|agent|secret|code)=[^\s&"'<>]+/gi;

export function removerDetalhesDaUrl(texto: string): string {
  return texto
    .replace(URL_ABSOLUTA_COM_DETALHES, '$1')
    .replace(CAMINHO_COM_DETALHES, '$1$2')
    .replace(PARAMETRO_SENSIVEL, '$1=[removido]');
}

function isObjetoSimples(valor: unknown): valor is Record<string, unknown> {
  return Object.prototype.toString.call(valor) === '[object Object]';
}

export function sanitizarValor<T>(valor: T): T;
export function sanitizarValor(valor: unknown): unknown {
  if (typeof valor === 'string') return removerDetalhesDaUrl(valor);
  if (Array.isArray(valor)) return valor.map((item) => sanitizarValor(item));
  if (!isObjetoSimples(valor)) return valor;

  return Object.fromEntries(
    Object.entries(valor).map(([chave, item]) => [chave, sanitizarValor(item)])
  );
}

/**
 * O Faro chama este hook sem try/catch. Se a limpeza falhar, o evento é
 * descartado: perder um evento é melhor que enviar dado sensível.
 */
export function sanitizarEvento<T extends { payload: unknown; meta: unknown }>(
  item: T
): T | null {
  try {
    return {
      ...item,
      payload: sanitizarValor(item.payload),
      meta: sanitizarValor(item.meta),
    };
  } catch {
    return null;
  }
}
